import React from 'react';

const TrainerSettings = () => {
    return (
        <div>
            this is trainer settings page
        </div>
    );
};

export default TrainerSettings;